module.exports = __webpack_public_path__ + "img/scheduledduration.6592a08c.png";